import { getAtlasPageIdFromOrgId } from './data/resources';
import { ATLAS_APP_BASE_URL } from '@/constants/index';

function getOrganizationDetailsLink(organizationID) {
    if (!organizationID || typeof organizationID !== 'string') return '';

    const atlasPageId = getAtlasPageIdFromOrgId(organizationID);

    if (atlasPageId) {
        return `${ATLAS_APP_BASE_URL}/pages/${atlasPageId}`;
    }
    return `${ATLAS_APP_BASE_URL}/org-${organizationID}`;
}

const getOrgId = (org) => org.organizationId ?? org.organization_id;

/**
 * Generates the filtering options for an organization filter, given a live set of organizations.
 * @param {Array} organizations
 * @returns {Array} An array of organization filter options, pass this directly into the filter metadata
 */
function organizationsToFilterOptions(organizations = []) {
    if (!Array.isArray(organizations)) return;

    return organizations
        .filter(getOrgId)
        .map((org) => ({
            value: getOrgId(org),
            text: org.name ?? '',
        }))
        .sort((a, b) => a.text.localeCompare(b.text)); // ASC order
}

export { getOrganizationDetailsLink, organizationsToFilterOptions };
